<template>
  <div class="pt-3">
    <span class="title-box text-capitalize">{{ $t('betBooked') }}</span>
    <v-card class="cart pa-2 pt-5 pb-5" elevation="1">
      <div class="pb-3 text-help text-center">{{ $t('helpBookedBet') }}</div>
      <v-text-field
        :label="$t('betCode')"
        outlined
        v-model="betCode"
        dense
        :hint="$t('hintBookedBet')"
        autocomplete="nope"
        type="text"
        :error-messages="errors"
        :success-messages="success"
        @change="removeAlerts"
        @keyup="removeAlerts"
      ></v-text-field>
      <div :class="['get-booked-bet-button']" @click="getBookedBet">
        {{ $t('loadBet') }}
      </div>
    </v-card>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'GetBookedBet',
  data: () => ({
    valid: true,
    betCode: '',
    errors: [],
    success: [],
  }),
  computed: {
    ...mapGetters({
      getLanguage: 'settings/getLanguage',
    }),
  },
  methods: {
    ...mapActions({
      setLoadingCart: 'cart/setLoadingCart',
      fetchBookedBet: 'cart/fetchBookedBet',
    }),
    async getBookedBet() {
      this.valid = this.betCode != ''
      if (this.valid) {
        await this.setLoadingCart({ status: true })
        const bet = await this.fetchBookedBet({ code: this.betCode })
        if (!bet.result) {
          this.success = []
          this.errors = [this.$t('betCodeNotValid')]
          await this.setLoadingCart({ status: false })
        } else {
          this.errors = []
          this.success = [this.$t('betCodeSuccess')]
          this.betCode = ''
          await this.setLoadingCart({ status: false })
        }
      } else {
        this.success = []
        this.errors = [this.$t('codeRequired')]
      }
    },
    async removeAlerts() {
      this.success = []
      this.errors = []
    },
  },
}
</script>
